import { render, staticRenderFns } from "./DealDetail.vue?vue&type=template&id=1d295882&"
import script from "./DealDetail.vue?vue&type=script&lang=js&"
export * from "./DealDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports